import React, { useEffect } from "react";
import clsx from "clsx";
import { Dialog, DialogContent, Grid } from "@mui/material";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import { isEmpty } from "@util/utils";
import { Alert, Typography } from "@curves/ui-base";
import { TimeLine } from "@curves/ui-shared";
import { ActivityRecordCard } from "@shared/components";
import {
	adaptPaymentChange,
	TimelineRecordItem
} from "@icoach/memberDetail/components/memberChangeRecord";
import { useMemberPaymentApi } from "@apis/useMemberPaymentApi";
import { ReadTextField } from "@icoach/components";

const PaymentHistoryDialog = React.forwardRef(({ className, open, sourceData, onClose }, ref) => {
	if (!open) return null;

	const { title, memberName, memberNo } = sourceData || {};

	const { getMemberPaymentHistoryApi } = useMemberPaymentApi();
	const [history, setHistory] = React.useState([]);

	const doGetMemberPaymentHistoryApi = async ({ memberID, memberPaymentID }) => {
		let resp = await getMemberPaymentHistoryApi({ memberID, paymentID: memberPaymentID });
		if (resp) {
			setHistory(resp);
		}
	};

	useEffect(() => {
			if (open) {
				doGetMemberPaymentHistoryApi(sourceData);
			}
		},
		// eslint-disable-next-line
		[open]);

	return (
		<Dialog className={clsx("simple-content", "dialog", className)} PaperProps={{ className: "wx-65rem" }}
				open={open} fullWidth>
			<GradientColorHeader onClose={onClose}>付款資料變更紀錄</GradientColorHeader>
			<DialogContent>
				<Typography className={"font-weight-bold"} variant={"h6"}>
					{title}
				</Typography>
				<Grid className={'mb-3'} spacing={2} container>
					<Grid xs={6} item>
						<ReadTextField label={"會員"}>{memberName}</ReadTextField>
					</Grid>
					<Grid xs={6} item>
						<ReadTextField label={"會員編號"}>{memberNo}</ReadTextField>
					</Grid>
				</Grid>
				{
					isEmpty(history) ? (
						<Alert color="info" severity="info" variant="filled" className="my-3">
							尚無參考資料
						</Alert>
					) : (
						<TimeLine as="ul" className="membership-record">
							{history.map((item) => {
								const itemData = adaptPaymentChange(item);
								return (
									<TimeLine.Item key={itemData.id} as="li">
										<TimelineRecordItem metainfo={itemData.timelineMetainfo}>
											<ActivityRecordCard status={itemData.type}>
												{itemData.pdfUrl && <ActivityRecordCard.PdfAttachment pdfUrl={itemData.pdfUrl} />}
											<ActivityRecordCard.Content style={isEmpty(itemData.descList) ? { display: "flex", alignItems: "center" } : undefined}>
													<div className="activity-record-card__main">
														<Typography variant="h6" className="title">
															{itemData.title}
														</Typography>
														{!isEmpty(itemData.descList) &&
															itemData.descList.map((desc, descIndex) => (
																<Typography key={descIndex} variant="body2" className="mb-1">
																	{desc.label ? `${desc.label}：${desc.text}` : desc.text}
																</Typography>
															))}
													</div>
											</ActivityRecordCard.Content>
											</ActivityRecordCard>
										</TimelineRecordItem>
									</TimeLine.Item>
								);
							})}
						</TimeLine>
					)
				}
			</DialogContent>
		</Dialog>
	);
});

export default PaymentHistoryDialog;